<template>
    <div class="mMobileCerveza-container" v-observe-visibility="startAnimate">
        <div class="mMobileImg">
            <img class="mMobileSign" :src="sign" :class="{animate: animate, onlySafari: isSafari}" alt="NUEVA Tecate 0.0% alcohol">
            <img class="mMobileTitle" :src="title" :class="{animate: animate, onlySafari: isSafari}" alt="El sabor refrescante Nueva Cerveza Tecate 0.0, con todo el sabor refrescante, notas de malta y sutiles aromas frutales. Un amargo característico y una espuma solida que le imprime carácter para completar la experiencia de una cerveza completa">
        </div>
        <div class="mMobileRow">
            <div class="mMobileLeft">
                <img class="mMobileCan" :src="can" :class="{animate: animate}" alt="Lata sleek 355ml">
                <h2 class="mMobilesubtitle-one" :class="{animate: animate, onlySafari: isSafari}">Lata sleek 355ml</h2>
                <img class="mMobileBottle" :src="bottle" :class="{animate: animate}" alt="Botella ret 325ml">
                <h3 class="mMobilesubtitle-two" :class="{animate: animate, onlySafari: isSafari}">Botella ret 325ml</h3>
            </div>
            <div class="mMobileRight">
                <div class="MobileAbove">
                    <img class="mMobileCan-icon" :src="can_icon" :class="{animate: animate, onlySafari: isSafari}" alt="71KCAL">
                    <img class="mMobileBottle-icon" :src="bottle_icon" :class="{animate: animate, onlySafari: isSafari}" alt="74KCAL">
                </div>
                <div class="mMobileCenter" :class="{animate: animate}"></div>
                <div class="mMobileBottom">
                    <img class="mMobileGlass" :src="glass" :class="{animate: animate}" alt="Vaso de cerveza dorado gracias a la malta que lleva en sus ingredientes">
                    <h2 class="mMobilesubtitle" :class="{animate: animate, onlySafari: isSafari}">Color <br/> dorado</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import sign from "@/assets/beer/SIGN_TECATE.png";
import title from "@/assets/beer/TITLE.png";
import glass from "@/assets/beer/GLASS.png";
import can_icon from "@/assets/beer/CAN_ICONO.png";
import bottle_icon from "@/assets/beer/BOTTLE_ICONO.png";
import can from "@/assets/beer/CAN_TECATE.png";
import bottle from "@/assets/beer/BOTTLE_TECATE.png";
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
    name: "MobileCerveza",
    data() {
        return {
            sign,
            title,
            glass,
            can_icon,
            bottle_icon,
            can,
            bottle,
            animate: false,
            isSafari: false
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        },
    },
    components: {},
    mounted() {
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/MobileCerveza.scss";
</style>